import ajax from "../assets/uilt/ajax";

let role = {
  add: (req) => {
    return ajax.post({
      url: "/back/role/add",
      param: req.param,
      success: req.success,
    });
  },
  getAllRole: (req) => {
    return ajax.get({
      url: "/back/role/get-all-role",
      param: req.param,
      success: req.success,
    });
  },
  updateById: (req) => {
    return ajax.post({
      url: "/back/role/update-by-id",
      param: req.param,
      success: req.success,
    });
  },
  getAllResource: (req) => {
    return ajax.get({
      url: "/back/role/get-all-resource",
      param: req.param,
      success: req.success,
    });
  },
};

export default role;
